const currentYear = new Date().getFullYear();

const locale = {
    code: "pt",
    label: "Português",
    NAV_BAR: {
        home: "Início",
        homeId: "home",
        aboutus: "Sobre Nós",
        aboutId: "aboutus",
        faq: "FAQ",
        faqId: "faq-section",
        contact: "Contato",
        contactId: "contact-section",
        button: "Obter Acesso",
    },

    HERO: {
        heroHeading: "Seu menu, acessível instantaneamente",
        heroParagraph:
            "Crie, atualize e compartilhe seu menu com um único código QR: sem complicações, sem reimpressões.",
        button: "Obter Acesso",
        downloadText: "Baixar em",
        appStore: "App Store",
        getItOn: "OBTENHA NO",
        googlePlay: "Google Play",
    },

    SERVICES: {
        heading: "Nossos Serviços",
        cards: [
            {
                title: "Criar e carregar menu",
                description:
                    "Crie e carregue seu menu facilmente com apenas alguns cliques. Adicione produtos, defina preços e atualize detalhes sem necessidade de conhecimento técnico.",
            },
            {
                title: "Atualizar menu",
                description:
                    "Atualize seu menu em tempo real quando quiser. Altere preços, adicione novos pratos ou arquive itens indisponíveis instantaneamente sem reimpressão.",
            },
            {
                title: "Gerar e compartilhar",
                description:
                    "Gere um código QR exclusivo para o seu menu instantaneamente. Compartilhe em mesas, cartazes ou online para que os clientes acessem seu menu mais recente.",
            },
        ],
    },

    FEATURES: {
        heading: "Descubra nossos recursos incríveis",
        lists: [
            {
                title: "Gerenciar menu",
                description:
                    "Gerencie seu menu a qualquer momento. Adicione, edite ou remova itens com facilidade para manter suas ofertas atualizadas.",
            },
            {
                title: "Relatórios e insights",
                description:
                    "Obtenha insights valiosos com relatórios em tempo real. Acompanhe visualizações de menu, varreduras de QR e engajamento do cliente.",
            },
            {
                title: "Compartilhamento de códigos QR",
                description:
                    "Compartilhe seu menu com um código QR exclusivo. Exiba em mesas, cartazes ou online para facilitar a varredura do cliente.",
            },
            {
                title: "Avaliações de clientes",
                description:
                    "Exiba feedback real e avaliações dos clientes. Crie confiança, melhore seu menu e proporcione uma melhor experiência gastronômica.",
            },
            {
                title: "Ofertas e descontos",
                description:
                    "Aumente as vendas com ofertas especiais e descontos. Destaque promoções de tempo limitado e descontos exclusivos.",
            },
        ],
    },

    ABOUT: {
        heading: "Sobre My QR Menu",
        headingPara: "Simplifique a gestão do menu do seu restaurante com atualizações em tempo real.",
        highlightHeading: "Acesso rápido e fácil a tudo que você precisa",
        highlightPara: "Todos os recursos do seu menu, com apenas um toque.",
        cards: {
            left: {
                heading: ["Adicione ingredientes", "facilmente ao seu menu QR"],
                alt: "Adicionar ingredientes",
            },
            right: {
                heading: ["Acesse seu", "painel de menu facilmente"],
                alt: "Painel do menu",
            },
        },
    },

    FAQ: {
        heading: "Você tem perguntas. Nós temos respostas.",
        subheading: "Tudo o que você precisa saber sobre o produto.",
        items: [
            {
                question: "O que é My QRMenu?",
                answer:
                    "My QRMenu é uma plataforma de menu digital que permite aos restaurantes criar, atualizar e compartilhar seus menus instantaneamente usando códigos QR.",
            },
            {
                question: "Posso atualizar meu menu depois de criá-lo?",
                answer:
                    "Sim, você pode atualizar seu menu a qualquer momento e ele aparecerá instantaneamente quando os clientes digitalizarem seu código QR.",
            },
            {
                question: "Como funciona o My QRMenu?",
                answer:
                    "Você cria um menu, gera um código QR e os clientes o digitalizam para ver a versão mais recente do seu menu.",
            },
            {
                question: "Como compartilho meu código QR?",
                answer:
                    "Você pode compartilhar o código QR digitalmente ou imprimi-lo para exibição em seu restaurante.",
            },
            {
                question: "O My QRMenu é compatível com dispositivos móveis?",
                answer:
                    "Sim, o My QRMenu é otimizado para todos os dispositivos, incluindo telefones celulares e tablets.",
            },
            {
                question: "Posso coletar avaliações de clientes?",
                answer:
                    "Sim, você pode ativar avaliações de clientes e usar o feedback para melhorar suas ofertas.",
            },
        ],
    },

    CONTACT: {
        heading: "Contate-nos",
        subheading: "Nossa equipe amigável adoraria ouvir de você.",
        firstName: "Nome",
        lastName: "Sobrenome",
        email: "E-mail",
        message: "Mensagem",
        firstNamePlaceholder: "Nome",
        lastNamePlaceholder: "Sobrenome",
        emailPlaceholder: "voce@empresa.com",
        messagePlaceholder: "Escreva sua mensagem...",
        privacyConsent: "Você concorda com nossa",
        privacyPolicy: "política de privacidade",
        submitButton: "Enviar mensagem",
        toast: {
            requiredConsent: "Você deve aceitar a política de privacidade.",
            submitting: "Enviando mensagem...",
            success: "Mensagem enviada com sucesso!",
            fail: "Falha ao enviar mensagem. Por favor, tente novamente.",
            error: "Ocorreu um erro. Por favor, verifique sua conexão.",
        },
    },

    HELP_PAGE: {
        title: "Centro de Ajuda",
        description: "Se você tiver alguma dúvida ou precisar de ajuda, entre em contato conosco em ",
        contactEmail: "contact@myqrmenu.co",
        faqPrompt: "Ou confira nossas perguntas frequentes abaixo, você pode encontrar o que procura.",
    },

    FOOTER: {
        footerHeading: "Menus digitais contínuos, simplificados.",
        footerButton: "Junte-se à lista de espera",
        footerConnect: "Conecte-se conosco",
        footerTerms: "Termos e acordos",
        footerHelp: "Centro de ajuda",
        footerPrivacy: "Política de privacidade",
        footerCopyright: `©${currentYear} Todos os direitos reservados.`,
    },

    PRIVACY_POLICY: {
        title: "Política de Privacidade",
        lastUpdated: "Última atualização: 22 de maio de 2025",
        content: `
            <article class="mb-12">
                <p class="mb-6 leading-relaxed">
                Esta Política de Privacidade descreve Nossas políticas e procedimentos sobre a coleta, uso e divulgação de Suas informações quando Você utiliza o Serviço.
                </p>
                <p class="mb-6 leading-relaxed">
                Utilizamos Seus dados pessoais para fornecer e melhorar o Serviço. Ao utilizar o Serviço, Você concorda com a coleta e uso de informações de acordo com esta Política de Privacidade.
                </p>
            </article>

            <section class="mb-12">
                <header class="mb-6">
                <h2 class="text-2xl font-semibold">Interpretação e Definições</h2>
                </header>
                <article class="mb-8">
                <h3 class="text-xl font-semibold mb-2">Interpretação</h3>
                <p class="mb-6 leading-relaxed">
                    As palavras cuja letra inicial é maiúscula têm significados definidos nas seguintes condições.
                </p>
                </article>

                <article>
                <h3 class="text-xl font-semibold mb-4">Definições</h3>
                <ul class="list-disc list-inside mb-6 space-y-3 text-gray-800">
                    <li><strong>Conta</strong> significa uma conta única criada para Você acessar nosso Serviço.</li>
                    <li><strong>Empresa</strong> refere-se a <strong>My QR Menu,</strong> Londres, Reino Unido.</li>
                    <li><strong>Dados Pessoais</strong> é qualquer informação que se relacione a um indivíduo identificado ou identificável.</li>
                    <li><strong>Você</strong> significa o indivíduo que acede ou utiliza o Serviço.</li>
                </ul>
                </article>
            </section>

            <section class="mb-12">
                <h2 class="text-2xl font-semibold mb-6">Contate-nos</h2>
                <p>
                Se você tiver alguma dúvida sobre esta Política de Privacidade, pode nos contatar:
                </p>
                <ul class="list-disc list-inside mt-2">
                <li>Por e-mail: <a href="mailto:hello@myqrmenu.co" class="text-gray-800 underline">hello@myqrmenu.co</a></li>
                </ul>
            </section>
        `
    },

    TERMS_AND_CONDITIONS: {
        title: "Termos e Condições",
        lastUpdated: "Última atualização: 22 de maio de 2025",
        content: `
            <p class="leading-relaxed mb-6">
            Leia estes Termos e Condições cuidadosamente antes de usar nosso Aplicativo ou Website.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">1. Interpretação e Definições</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">Interpretação</h3>
            <p class="leading-relaxed mb-4">
            As palavras cuja letra inicial é maiúscula têm significados definidos nas seguintes condições.
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">Definições</h3>
            <ul class="list-disc list-inside mb-6 leading-relaxed text-gray-800">
            <li><strong>Aplicação</strong> significa o software fornecido pela My QR Menu.</li>
            <li><strong>Empresa</strong> refere-se à My QR Menu, sediada em Londres, Reino Unido.</li>
            <li><strong>Serviço</strong> refere-se à Aplicação e ao Website.</li>
            <li><strong>Você</strong> significa o indivíduo ou empresa que acede ao Serviço.</li>
            </ul>

            <h2 class="text-2xl font-semibold mt-10 mb-4">2. Reconhecimento</h2>
            <p class="leading-relaxed mb-6">
            Ao aceder ou utilizar o Serviço, Você concorda em estar vinculado a estes Termos. Se Você discordar de qualquer parte, não poderá aceder ao Serviço.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">3. Links para Outros Websites</h2>
            <p class="leading-relaxed mb-6">
            Nosso Serviço pode conter links para sites de terceiros. Não assumimos responsabilidade pelo seu conteúdo ou práticas.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">4. Rescisão</h2>
            <p class="leading-relaxed mb-6">
            Reservamo-nos o direito de rescindir ou suspender o Seu acesso ao Serviço imediatamente, sem aviso prévio, por qualquer motivo.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">5. Limitação de Responsabilidade</h2>
            <p class="leading-relaxed mb-6">
            Na extensão máxima permitida por lei, a Empresa não será responsável por quaisquer danos decorrentes do uso do Serviço.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">6. Isenção de Responsabilidade "TAL COMO ESTÁ" e "CONFORME DISPONÍVEL"</h2>
            <p class="leading-relaxed mb-6">
            O Serviço é fornecido a Você "TAL COMO ESTÁ" e "CONFORME DISPONÍVEL". Não garantimos que o Serviço estará livre de erros ou interrupções.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">7. Lei Aplicável</h2>
            <p class="leading-relaxed mb-6">
            Estes Termos serão regidos pelas leis do Reino Unido.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">8. Resolução de Disputas</h2>
            <p class="leading-relaxed mb-6">
            Se Você tiver uma disputa conosco, concorda em tentar resolvê-la informalmente antes de tomar medidas legais.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">9. Para Usuários da União Europeia (UE)</h2>
            <p class="leading-relaxed mb-6">
            Se Você for um consumidor na UE, tem direito à proteção das disposições obrigatórias da lei do seu país de residência.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">10. Conformidade Legal nos Estados Unidos</h2>
            <p class="leading-relaxed mb-6">
            Você declara e garante que não está localizado em um país sujeito a sanções do governo dos EUA.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">11. Divisibilidade e Renúncia</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">Divisibilidade</h3>
            <p class="leading-relaxed mb-4">
            Se qualquer disposição destes Termos for considerada inexequível, as disposições restantes permanecerão em vigor.
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">Renúncia</h3>
            <p class="leading-relaxed mb-6">
            A falha em aplicar uma disposição não constituirá uma renúncia a tal direito.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">12. Interpretação da Tradução</h2>
            <p class="leading-relaxed mb-6">
            Estes Termos podem ter sido traduzidos. Em caso de disputa, a versão em inglês prevalecerá.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">13. Alterações a estes Termos</h2>
            <p class="leading-relaxed mb-6">
            Podemos atualizar estes Termos a qualquer momento. Iremos notificá-lo publicando um aviso em nosso Website.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">14. Contate-nos</h2>
            <p class="leading-relaxed mb-2">Se você tiver alguma dúvida sobre estes Termos, pode nos contatar:</p>
            <ul class="list-disc list-inside text-gray-800">
            <li>Por e-mail: <a href="mailto:hello@myqrmenu.co" class="text-blue-600 underline">hello@myqrmenu.co</a></li>
            </ul>
        `
    }
};

export default locale;
